// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getShippingLocations () {

    const endPoint = `${basePath}/inventory-locations/type/regular`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function getPastDueShipments ( shippingLocationVal ) {

    const endPoint = `${basePath}/pastdue-shipments`;
    const payLoad = {
        shippingLocation: shippingLocationVal
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}
